import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { DownloadableConfigurationFiles } from '../../../_lib/components/ConfigurationFileUpload';

type ConfigurationFile = {
  fileExportType: 'standard' | 'customized';
  fileExtension: 'yaml' | 'json';
  url: string;
};
type ConfigurationAggregateDefaultProps = { files: ConfigurationFile[] };

function ConfigurationAggregateDefault({ files }: ConfigurationAggregateDefaultProps) {
  const { uuid, elementType } = useBlockContext();
  const { t } = useSonTranslation('ConfigurationAggregate');
  return (
    <DownloadableConfigurationFiles
      key={`${elementType}-${uuid}`}
      files={files.map(file => ({
        extension: file.fileExtension,
        url: file.url,
        name: t(`fileExportType.${file.fileExportType}`),
      }))}
    />
  );
}

export const ConfigurationAggregateDefaultView = asView(ConfigurationAggregateDefault);
export type ConfigurationAggregateDefaultView = ComponentProps<typeof ConfigurationAggregateDefaultView>;
